import { MessageCircle } from 'lucide-react'
import type { ReactNode } from 'react'

import type { PartySummary } from '@aeris/contracts'
import { partyDisplayName } from '@aeris/party'
import { CopyableValue } from '@aeris/ui'

import { formatPhone } from '../lib/phone-format.ts'
import { whatsappLink } from '../lib/whatsapp-link.ts'

/**
 * Quem é o cliente, no cabeçalho da ficha e do Editar cadastro — F248.
 *
 * O mesmo defeito do produto: o título era "Editar cadastro", e a ficha não
 * trazia nem o telefone, que é a primeira coisa que o balcão procura. O código
 * é o que o pedido da loja e o caixa mostram; o telefone abre o WhatsApp.
 */
export const PartyIdentity = ({
  party,
}: {
  readonly party: PartySummary
}): ReactNode => {
  const phone = party.mainPhone ?? null
  const chat = whatsappLink(phone, '')

  return (
    <>
      {party.code == null ? null : (
        <CopyableValue
          label="Cód."
          value={String(party.code)}
          what="código do cliente"
        />
      )}
      {party.externalCode === null ? null : (
        <CopyableValue
          label="Cód. antigo"
          value={party.externalCode}
          what="código antigo"
        />
      )}
      {phone === null ? null : (
        <span className="inline-flex items-center gap-1">
          <CopyableValue
            label="Tel."
            value={phone}
            display={formatPhone(phone)}
            what="telefone"
          />
          {chat === null ? null : (
            <a
              href={chat}
              target="_blank"
              rel="noreferrer"
              aria-label={`Abrir o WhatsApp de ${partyDisplayName(party)}`}
              title="Abrir o WhatsApp"
              className="inline-flex items-center rounded-(--radius-sm) p-1 text-(--success) hover:bg-(--surface-hover)"
            >
              <MessageCircle aria-hidden="true" className="h-3.5 w-3.5" />
            </a>
          )}
        </span>
      )}
    </>
  )
}
